import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Tabs, type Tab } from '@node-space/ui-components'
import { Card } from 'services/CardService'
import { CardActivityTab } from './CardActivityTab'
import { CardDetailsTab } from './CardDetailsTab'

interface CardDetailsSidePanelBodyProps {
  card: Card
  onFreeze?: () => void
}

export const CardDetailsSidePanelBody = ({ card, onFreeze }: CardDetailsSidePanelBodyProps) => {
  const { t } = useTranslation()

  const tabs: Tab[] = [
    {
      id: 'card-details',
      header: t('customers.cardDetailsSidePanel.tabCardDetails'),
      content: <CardDetailsTab card={card} onFreeze={onFreeze} />,
    },
    {
      id: 'activity',
      header: t('customers.cardDetailsSidePanel.tabActivity'),
      content: <CardActivityTab />,
    },
  ]

  return (
    <Box width="full">
      <Tabs tabs={tabs} testId="card-details-side-panel-tabs" />
    </Box>
  )
}
